import palette from './palette';
import fonts from './fonts';
import theme from './theme';

export default {
  MuiCssBaseline: {
    styleOverrides: fonts,
  },
  MuiFormControl: {
    styleOverrides: {
      root: {
        '& .MuiOutlinedInput-root': {
          padding: '10px 14px !important',
          backgroundColor: palette.grey[50],

          '& fieldset': {
            border: `1px solid ${palette.grey[200]}`,
          },
          '&:not(.Mui-focused):hover fieldset': {
            border: `1px solid ${palette.grey[300]}`,
          },
        },
        '& input': {
          padding: '0',
          '&:-webkit-autofill': {
            WebkitBoxShadow: '0 0 0 1000px white inset',
          },
        },
        '& .MuiAutocomplete-input': {
          padding: '0 !important',
        },
        '& .MuiSelect-select': {
          padding: 0,
        },
      },
    },
  },
  MuiInputLabel: {
    styleOverrides: {
      outlined: {
        transform: 'translate(14px, 10px) scale(1)',
      },
      shrink: {
        transform: 'translate(14px, -8px) scale(0.75) !important',
      },
    },
  },
  MuiInputAdornment: {
    styleOverrides: {
      root: {
        '& svg': {
          color: palette.primary.main,
        },
      },
    },
  },
  MuiFormLabel: {
    styleOverrides: {
      asterisk: {
        color: palette.primary.main,
        '&$error': {
          color: palette.primary.main,
        },
      },
    },
  },
};
